export default "/images/OncologyLearningNetwork.jpg?ac37d552df7a67c465488da0f6443d27";